import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function BoldIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 4C6.33579 4 6 4.33579 6 4.75V12.25V19.25C6 19.6642 6.33579 20 6.75 20H13.75C16.0972 20 18 18.0972 18 15.75C18 14.0203 16.9668 12.532 15.4838 11.8686C16.4138 11.0442 17 9.84056 17 8.5C17 6.01472 14.9853 4 12.5 4H6.75ZM12.5 11.5C14.1569 11.5 15.5 10.1569 15.5 8.5C15.5 6.84314 14.1569 5.5 12.5 5.5H7.5V11.5H12.5ZM7.5 13V18.5H13.75C15.2688 18.5 16.5 17.2688 16.5 15.75C16.5 14.2312 15.2688 13 13.75 13H12.5H7.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
